export default __webpack_public_path__ + "locales/ro/Files.json?hash=65a0363486281e549954fcf0fc7da5d3";